import { showErrorAlert } from "../helpers/alert";
import apiClient from "../helpers/apiClient";
import { handleApiError, parseApiErrors } from "../utils/handleApiError";

export const getIntroductionTypes = async () => {
    const { data } = await apiClient.get('/members/introductions/catalog/');
    return data?.results;
};

export async function getCostIntroduction(params:any) {
    try {
        const response = await apiClient.post(`/members/introductions/check-cost/`,params);
        return response.data;
    } catch (error) {
        handleApiError(error, {
            onBadRequest: (data) => {
                let msg = parseApiErrors(data);
                showErrorAlert({ title: 'Important', message: msg })
            }
        });
    }
}

export const createIntroduction = async (payload: any) => {
    const { data } = await apiClient.post('/members/introductions/', payload);
    return data;
};

export async function getMyIntroductions(params:any) {
    try {
        const response = await apiClient.get(`/members/introductions/`,{ params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getMyIntroductionDetail(id:number) {
    try {
        const response = await apiClient.get(`/members/introductions/${id}/`);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function updateStatusIntroduction(id:number,data: any) {
    try {
        const response = await apiClient.put(`/members/introductions/${id}/`, data);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

/* admin services */

export async function getIntroductions(params:any) {
    try {
        const response = await apiClient.get(`/admin/introductions/`,{ params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getIntroductionDetailById(id:number) {
    try {
        const response = await apiClient.get(`/admin/introductions/${id}/`);
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}